import { Collapse } from 'antd';
import { RichText } from 'prismic-reactjs';
import React from 'react';
import { stripHtml } from '../../lib/html_strip';
import { questionHtmlSerializer } from '../../lib/serializers';
import { linkResolver, PrismicDocument, PrismicQa } from '../../prismic';
import styles from './question_collapse.less';

export const QuestionsCollapse: React.FC<{
  qas: PrismicDocument<PrismicQa>[];
}> = (props) => {
  const { qas } = props;
  return (
    <>
      <Collapse expandIconPosition="end" className={styles.questions}>
        {qas.map((qa) => {
          return (
            <Collapse.Panel header={RichText.asText(qa.data.question)} key={qa.id}>
              <div className={styles.answer}>
                <RichText
                  render={qa.data.answer}
                  linkResolver={linkResolver as any}
                  htmlSerializer={questionHtmlSerializer}
                ></RichText>
              </div>
            </Collapse.Panel>
          );
        })}
      </Collapse>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: qas.map((qa) => {
              return {
                '@type': 'Question',
                name: RichText.asText(qa.data.question),
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: stripHtml(RichText.asText(qa.data.answer)),
                },
              };
            }),
          }),
        }}
      ></script>
    </>
  );
};
